<script>
	import * as yup from 'yup';
	import { Form, isInvalid } from 'svelte-yup';
	import Message from './MyMessage.svelte';
	// import MyMessage from './MyMessage.svelte';
	import axios from 'axios';
	import Link from 'svelte-link';
	import {
		Row,
		Col,
		CardBody,
		Card,
		Container,
		// Form,
		Label,
		Input,
		Button,
		Alert,
		Modal, ModalHeader, ModalBody, ModalFooter
	} from '@sveltestrap/sveltestrap';
	import profileImg from '../../../assets/images/profile-img.png';
	import logo from '../../../assets/images/logo.svg';
	import { goto } from '$app/navigation';
	import { base } from '$app/paths';
	import { apiEndpoint } from '../../../services/api.js';

	export let embedded = false;
	export let onLogin = undefined;
	export let onClose = undefined;


	let modal_account_created = false;
	let isSubmitting = false;

	const regSchema = yup.object({
		Username: yup.string().required().label('Username').min(4).test(
			'Unique-Username',
			'Username already in use',
			async function testEmail(value) {
				if (value === '') {
					return true;
				}
				//
				let check_username = await new Promise((resolve, reject) => {
					let url = `${apiEndpoint}/dcns/CheckUsernameExists/` +
						encodeURIComponent(value) + '/';
					axios.get(url, { timeout: 2000 })
						.then((res) => {
							resolve({ result: res.data.exists, message: '' });
						})
						.catch((error) => {
							resolve({ result: false, message: error.message });
						});
				});

				let r_res = !check_username.result;
				if (check_username.message !== '') {
					r_res = this.createError({ message: check_username.message });
				}
				console.log('Username check on [' + value + '] invalid is ' + r_res);
				return r_res;
			}),
		Firstname: yup.string().required().max(30).label('Firstname'),
		Lastname: yup.string().required().max(30).label('Lastname'),
		Email: yup.string().email('Must be a valid Email').required().label('Email address').test({
			name: 'Unique-Email',
			message: 'Email already in use, please use account recovery process',
			skipUndefined: true,
			test: async function(value) {
				if (value === '') {
					return true;
				}
				//
				let username_test = await new Promise((resolve, reject) => {
					let url = `${apiEndpoint}/dcns/CheckEmailExists/` +
						encodeURIComponent(value) + '/';
					axios.get(url, { timeout: 2000 })
						.then((res) => {
							resolve({ result: res.data.exists, message: '' });
						})
						.catch((error) => {
							resolve({ result: false, message: error.message });
						});
				});
				let r_res = !username_test.result;
				if (username_test.message !== '') {
					r_res = this.createError({ message: username_test.message });
				}
				console.log('Password check on ', value, ' is ', r_res);
				return r_res;
			}
		}),
		Password: yup.string().required().min(8).label('Password'),
		Password2: yup.string().required().oneOf([yup.ref('Password'), null], 'Passwords must match')
	});

	let fields = {
		Username: '',
		Firstname: '',
		Lastname: '',
		Email: '',
		Password: '',
		Password2: ''
	};

	let submitted = false;

	function reg_user() {
		isSubmitting = true;
		let url = `${apiEndpoint}/dcns/new-signup/`;
		axios.post(url, fields)
			.then((res) => {
				console.log('Registration response', res);
				if (res.data.result === true) {
					// goto(`${base}/auth/login`);
					modal_account_created = true;
					// alert('Registration successful, please check your email for verification link');
				} else {
					alert('Registration failed, on backend: ' + res.data.reason);
				}
			}).catch((error) => {
			console.log('Registration error', error);
			alert('Registration failed, please try again later, go error:' + error.message);
		}).finally(() => {
			isSubmitting = false;
		});
	}

	function formSubmit() {
		console.log('Form submitted');
		submitted = true;
		regSchema.isValid(fields).then((isValid) => {
			if (isValid) {
				console.log('Form submitted');
				//
				// call the backend and submit the form.
				reg_user();
			} else {
				console.log('Form not submitted as invalid fields found');
			}
		});
	}


	//
	// this is needed to update the form invalid status
	$: invalid = (name) => {
		if (submitted) {
			let res = isInvalid(regSchema, name, fields);
			// console.log('Checking invalid for', name, ' is ', res);
			return res;
		}
		return false;
	};

	const removeBodyCss = () => {
		document.body.classList.add('no_padding');
	};

	function modal_close() {
		modal_account_created = false;
		if (embedded) {
			onClose?.();
			return;
		}
		removeBodyCss();
		goto(`${base}/welcome`);
	};
</script>

<Container>
	<Row class="justify-content-center">
		<Col md={embedded ? undefined : 8} lg={embedded ? undefined : 8} xl={embedded ? undefined : 5}>
			<Card class="overflow-hidden">
				<div class="bg-primary-subtle">
					<Row>
						<Col class="col-7">
							<div class="text-primary p-4">
								<h5 class="text-primary">Free Register</h5>
								<p>Get your free D-Cine.net account now.</p>
							</div>
						</Col>
						<Col class="col-5 align-self-end">
							<img src={profileImg} alt="" class="img-fluid" />
						</Col>
					</Row>
				</div>
				<CardBody class="pt-0">
					<div>
						<Link href="{base}/welcome">
							<div class="avatar-md profile-user-wid mb-4">
									<span class="avatar-title rounded-circle bg-light">
										<img src={logo} alt="" class="rounded-circle" height="34" />
									</span>
							</div>
						</Link>
					</div>
					<div class="p-2">
						{#if embedded && modal_account_created}
							<Alert color="success" isOpen>
								Thank you. Your account has been prepared. Please check your email for the verification link.
							</Alert>
							<Button color="secondary" on:click={modal_close}>Close</Button>
						{:else}
						<Form class="needs-validation" schema={regSchema} {fields} submitHandler={formSubmit} {submitted}>
							<div class="mb-3">
								<Label for="email" class="form-label">Email</Label>
								<Input
									type="email"
									class="form-control"
									id="email"
									invalid={invalid("Email")}
									placeholder="Enter email"
									bind:value={fields.Email}
								/>
								<div class="invalid-feedback">
									<Message name="Email" />
								</div>
							</div>

							<div class="mb-3">
								<Label for="username" class="form-label">Username</Label>
								<Input
									type="text"
									class="form-control"
									id="username"
									pattern="[A-Za-z0-9]*"
									placeholder="Enter username"
									invalid={invalid("Username")}
									bind:value={fields.Username}
									on:input={(e) => {
										const regex = /^[A-Za-z0-9]*$/;
										if (!regex.test(e.target.value)) {
											e.target.value = e.target.value.replace(/[^A-Za-z0-9]/g, '');
										}
										fields.Username = e.target.value;
									}}
								/>
								<div class="invalid-feedback">
									<Message name="Username" />
								</div>
							</div>

							<div class="mb-3">
								<Label for="firstname" class="form-label">Firstname</Label>
								<Input
									type="text"
									class="form-control"
									id="firstname"
									placeholder="Enter Firstname"
									invalid={invalid("Firstname")}
									bind:value={fields.Firstname}
								/>
								<div class="invalid-feedback">
									<Message name="Firstname" />
								</div>
							</div>

							<div class="mb-3">
								<Label for="lastname" class="form-label">Lastname</Label>
								<Input
									type="text"
									class="form-control"
									id="lastname"
									placeholder="Enter Lastname"
									invalid={invalid("Lastname")}
									bind:value={fields.Lastname}
								/>
								<div class="invalid-feedback">
									<Message name="Lastname" />
								</div>
							</div>

							<div class="mb-3">
								<Label for="password" class="form-label">Password</Label>
								<Input
									type="password"
									class="form-control"
									id="password"
									placeholder="Enter password"
									invalid={invalid("Password")}
									bind:value={fields.Password}
								/>
								<div class="invalid-feedback">
									<Message name="Password" />
								</div>
							</div>

							<div class="mb-3">
								<Label for="userpassword2" class="form-label">Password again</Label>
								<Input
									type="password"
									class="form-control"
									id="userpassword2"
									placeholder="Enter password again"
									invalid={invalid("Password2")}
									bind:value={fields.Password2}
								/>
								<div class="invalid-feedback">
									<Message name="Password2" />
								</div>
							</div>

							<div class="mt-4 d-grid">
								{#if isSubmitting}
									<Button color="primary" class="waves-effect waves-light" type="submit" disabled>
										Submitting...
									</Button>
								{:else}
									<Button color="primary" class="waves-effect waves-light" type="submit">
										Register
									</Button>
								{/if}
							</div>
							<div class="mt-4 text-center">
								<p class="mb-0">
									By registering you agree to the D-Cine.net
									<Link href="https://www.d-cine.net/d-cine-net-portal-terms-of-service/"
												target="_blank" class="text-primary"
									>Terms of Service
									</Link>
									and
									<Link href="https://www.d-cine.net/privacy-policy/"
												target="_blank" class="text-primary"
									>Privacy Policy
									</Link>

								</p>
							</div>
						</Form>
						{/if}

					</div>
				</CardBody>
			</Card>
			<div class="mt-5 text-center">
				<p>
					Already have an account ?
					{#if embedded}
						<button type="button" class="btn btn-link p-0 fw-medium" on:click={onLogin}>Login</button>
					{:else}
						<Link href="{base}/auth/login" class="fw-medium text-primary">Login</Link>
					{/if}
				</p>
				<p>
					© {new Date().getFullYear()} D-Cine.net
				</p>
			</div>
		</Col>
	</Row>
</Container>

{#if !embedded}
<Modal isOpen={modal_account_created} toggle={modal_close}>
	<ModalHeader toggle={modal_close}>Account Created</ModalHeader>
	<ModalBody>
		Thank you. Your account has been prepared. Please check your email for the verification link.
	</ModalBody>
	<ModalFooter>
		<Button color="secondary" on:click={modal_close}>Close</Button>
	</ModalFooter>
</Modal>
{/if}

<style>

    .invalid-feedback {
        font-size: 1.8em !important;
    }

</style>
